// Types
import { UpdateAiTemplateTypeType } from 'Shared/types/UpdateAiTemplate.type';

// API
import * as api from '../api/UpdateAiSettings.api';

// Utils
import normalizer from 'Shared/utils/normalizeJSON/normalizer';

// Schemas
import UpdateAiTemplateSchema from 'Shared/utils/normalizeJSON/schemas/UpdateAiTemplate.schema';
import UpdateAiSettingSchema from 'Shared/utils/normalizeJSON/schemas/UpdateAiSetting.schema';
import UpdateAiTemplateSctionSchema from 'Shared/utils/normalizeJSON/schemas/UpdateAiTemplateSection.schema';

// Constants
import UpdateAiSettingsConstants from 'Shared/constants/UpdateAiSettings.constants';

export const fetchDefaultTemplatesSuccess = payload => ({
  type: UpdateAiSettingsConstants.Actions.FETCH_DEFAULT_TEMPLATES_SUCCESS,
  payload,
});

export const createUpdateAiSettingSuccess = payload => ({
  type: UpdateAiSettingsConstants.Actions.CREATE_UPDATE_AI_SETTING_SUCCESS,
  payload,
});

export const fetchUpdateAiSettingSuccess = payload => ({
  type: UpdateAiSettingsConstants.Actions.FETCH_UPDATE_AI_SETTING_SUCCESS,
  payload,
});

export const updateUpdateAiSettingSuccess = payload => ({
  type: UpdateAiSettingsConstants.Actions.UPDATE_UPDATE_AI_SETTING_SUCCESS,
  payload,
});

export const createUpdateAiTemplateSectionSuccess = payload => ({
  type: UpdateAiSettingsConstants.Actions.CREATE_UPDATE_AI_TEMPLATE_SECTION_SUCCESS,
  payload,
});

export const updateUpdateAiTemplateSectionSuccess = payload => ({
  type: UpdateAiSettingsConstants.Actions.UPDATE_UPDATE_AI_TEMPLATE_SECTION_SUCCESS,
  payload,
});

export const removeUpdateAiSettingTemplateSectionSuccess = payload => ({
  type: UpdateAiSettingsConstants.Actions.REMOVE_UPDATE_AI_TEMPLATE_SECTION_SUCCESS,
  payload,
});

export const createUpdateAiReportSectionsSuccess = payload => ({
  type: UpdateAiSettingsConstants.Actions.CREATE_UPDATE_AI_REPORT_SECTIONS_SUCCESS,
  payload,
});

export const catchUpdateAiSocketSuccess = payload => ({
  type: UpdateAiSettingsConstants.Actions.CATCH_UPDATE_AI_SOCKET_SUCCESS,
  payload,
});

export const removeCurrentlyGneratingSlug = payload => ({
  type: UpdateAiSettingsConstants.Actions.REMOVE_CURRENTLY_GENERATING_SECTION_SLUG,
  payload,
});

export const updateUpdateAiSettingReportSuccess = payload => ({
  type: UpdateAiSettingsConstants.Actions.UPDATE_UPDATE_AI_SETTING_REPORT_SUCCESS,
  payload,
});

export const fetchDefaultTemplates = () => dispatch => {
  return api.fetchDefaultTemplates().then(response => {
    const normalized = normalizer(UpdateAiTemplateSchema, response.data);
    dispatch(fetchDefaultTemplatesSuccess(normalized));
    return response;
  });
};

type createUpdateAiSettingType = {
  templateType: UpdateAiTemplateTypeType;
};

export const createUpdateAiSetting = ({ templateType }: createUpdateAiSettingType) => dispatch => {
  const data = {
    update_ai_setting: {
      template_type: templateType,
    },
  };

  return api.createUpdateAiSetting(data).then(response => {
    const normalized = normalizer(UpdateAiSettingSchema, response.data);
    dispatch(createUpdateAiSettingSuccess(normalized));
    return response;
  });
};

type fetchUpdateAiSettingType = {
  slug: string;
};

export const fetchUpdateAiSetting = ({ slug }: fetchUpdateAiSettingType) => dispatch => {
  return api.fetchUpdateAiSetting({ slug }).then(response => {
    const normalized = normalizer(UpdateAiSettingSchema, response.data);
    dispatch(fetchUpdateAiSettingSuccess(normalized));
    return response;
  });
};

type updateUpdateAiSettingType = {
  slug: string;
  dataSources?;
};

export const updateUpdateAiSetting = ({ slug, dataSources }: updateUpdateAiSettingType) => dispatch => {
  const data = {
    update_ai_setting: {
      data_sources: dataSources,
    },
  };

  return api.updateUpdateAiSetting({ slug, data }).then(response => {
    const normalized = normalizer(UpdateAiSettingSchema, response.data);
    dispatch(updateUpdateAiSettingSuccess(normalized));
    return response;
  });
};

type createUpdateAiSettingTemplateSectionProps = {
  slug: string;
  data: {
    title: string;
    description: string;
  };
};

export const createUpdateAiSettingTemplateSection = ({
  slug,
  data,
}: createUpdateAiSettingTemplateSectionProps) => dispatch => {
  const formattedData = {
    update_ai_template_section: {
      ...data,
    },
  };

  return api.createUpdateAiTemplateSection({ slug, data: formattedData }).then(response => {
    const normalized = normalizer(UpdateAiTemplateSctionSchema, response.data);
    dispatch(createUpdateAiTemplateSectionSuccess({ slug, data: normalized }));
    return response;
  });
};

type updateUpdateAiSettingTemplateSectionProps = {
  slug: string;
  templateSectionSlug: string;
  data: {
    title: string;
    description: string;
  };
};

export const updateUpdateAiSettingTemplateSection = ({
  slug,
  templateSectionSlug,
  data,
}: updateUpdateAiSettingTemplateSectionProps) => dispatch => {
  const formattedData = {
    update_ai_template_section: {
      ...data,
    },
  };

  return api.updateUpdateAiTemplateSection({ slug, templateSectionSlug, data: formattedData }).then(response => {
    const normalized = normalizer(UpdateAiTemplateSctionSchema, response.data);
    dispatch(updateUpdateAiTemplateSectionSuccess(normalized));
    return response;
  });
};

type removeUpdateAiSettingTemplateSectionProps = {
  slug;
  templateSectionSlug: string;
};

export const removeUpdateAiSettingTemplateSection = ({
  slug,
  templateSectionSlug,
}: removeUpdateAiSettingTemplateSectionProps) => dispatch => {
  return api.removeUpdateAiTemplateSection({ slug, templateSectionSlug }).then(response => {
    dispatch(removeUpdateAiSettingTemplateSectionSuccess({ slug, templateSectionSlug }));
    return response;
  });
};
